<template>
  <div id="computation" class="textblock">
    <vue-markdown>
# Analysis

## [Computation](#/computation)

To examine the collected data, the amount of power generated per unit weight of gunpowder is computed using exterior ballistics.

## [Drag Model](#/dragmodel)

The exterior ballistics depends heavily on the accurate calculation of atmospheric drag.  Some of the source data was recorded specifically to help determine drag effects.

## [Interpretation](#/interpretation)

The data varies in quality and includes results on both good and bad gunpowder.  Some statistical analysis can be performed to try to identify trends.
    </vue-markdown>
  </div>
</template>

<style src="./textblock.css" scoped/>

<script>
export default {
  name: 'Analysis'
}
</script>
